import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertWarning = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12.0001 19.5L12 19.5", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 4V14", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconAlertWarning.js.map